import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _67a4dd8d = () => interopDefault(import('../pages/acknowledgement.vue' /* webpackChunkName: "pages/acknowledgement" */))
const _71316e08 = () => interopDefault(import('../pages/active-queues.vue' /* webpackChunkName: "pages/active-queues" */))
const _1a577800 = () => interopDefault(import('../pages/customer-feedback-layout.vue' /* webpackChunkName: "pages/customer-feedback-layout" */))
const _88a70900 = () => interopDefault(import('../pages/customer-feedback-one.vue' /* webpackChunkName: "pages/customer-feedback-one" */))
const _2951001c = () => interopDefault(import('../pages/ended-queues.vue' /* webpackChunkName: "pages/ended-queues" */))
const _08cf31af = () => interopDefault(import('../pages/feedback-acknowledgement.vue' /* webpackChunkName: "pages/feedback-acknowledgement" */))
const _64911237 = () => interopDefault(import('../pages/help-function.vue' /* webpackChunkName: "pages/help-function" */))
const _5d31cec7 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _73324647 = () => interopDefault(import('../pages/missed-queues.vue' /* webpackChunkName: "pages/missed-queues" */))
const _62507dd9 = () => interopDefault(import('../pages/queue-details.vue' /* webpackChunkName: "pages/queue-details" */))
const _79c32444 = () => interopDefault(import('../pages/rate-our-service.vue' /* webpackChunkName: "pages/rate-our-service" */))
const _41496dcc = () => interopDefault(import('../pages/search-queues.vue' /* webpackChunkName: "pages/search-queues" */))
const _ede43562 = () => interopDefault(import('../pages/service-dashboard.vue' /* webpackChunkName: "pages/service-dashboard" */))
const _81b2df82 = () => interopDefault(import('../pages/stored-queues.vue' /* webpackChunkName: "pages/stored-queues" */))
const _8366906c = () => interopDefault(import('../pages/toggle-call.vue' /* webpackChunkName: "pages/toggle-call" */))
const _4fa3be25 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/acknowledgement",
    component: _67a4dd8d,
    name: "acknowledgement"
  }, {
    path: "/active-queues",
    component: _71316e08,
    name: "active-queues"
  }, {
    path: "/customer-feedback-layout",
    component: _1a577800,
    name: "customer-feedback-layout"
  }, {
    path: "/customer-feedback-one",
    component: _88a70900,
    name: "customer-feedback-one"
  }, {
    path: "/ended-queues",
    component: _2951001c,
    name: "ended-queues"
  }, {
    path: "/feedback-acknowledgement",
    component: _08cf31af,
    name: "feedback-acknowledgement"
  }, {
    path: "/help-function",
    component: _64911237,
    name: "help-function"
  }, {
    path: "/logout",
    component: _5d31cec7,
    name: "logout"
  }, {
    path: "/missed-queues",
    component: _73324647,
    name: "missed-queues"
  }, {
    path: "/queue-details",
    component: _62507dd9,
    name: "queue-details"
  }, {
    path: "/rate-our-service",
    component: _79c32444,
    name: "rate-our-service"
  }, {
    path: "/search-queues",
    component: _41496dcc,
    name: "search-queues"
  }, {
    path: "/service-dashboard",
    component: _ede43562,
    name: "service-dashboard"
  }, {
    path: "/stored-queues",
    component: _81b2df82,
    name: "stored-queues"
  }, {
    path: "/toggle-call",
    component: _8366906c,
    name: "toggle-call"
  }, {
    path: "/",
    component: _4fa3be25,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
